import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalProvider } from "@air/provider-modal";
import { ShortIdProvider } from "@air/provider-short-id";
import { ErrorBoundary } from "@air/utils-error";
import { ConnectedRouter } from "connected-next-router";
import { AccountProvisionerProvider } from "~/components/AccountProvisioner/providers/AccountProvisionerProvider";
import { MaintenanceMode } from "~/components/MaintenanceMode/MaintenanceMode";
import { PublicAsset } from "~/components/PublicAssetModal/PublicAsset";
import { PublicAssetReduxProvider } from "~/components/PublicAssetReduxProvider";
import { PublicClipActivityContainer } from "~/components/PublicClipActivityContainer";
import { PublicClipSocketContextProvider } from "~/components/PublicClipSocketContextProvider";
import { PublicPermissionsProvider } from "~/components/PublicPermissionsProvider";
import { PublicWorkspaceProvider } from "~/components/PublicWorkspaceProvider";
import { PublicAccountProvider } from "~/providers/AccountProvider";
import { AnnotationProvider } from "~/providers/AnnotationProvider/AnnotationProvider";
import { FiltersProvider } from "~/providers/FiltersProvider";
import { PublicClipCustomFieldsProvider } from "~/providers/PublicClipCustomFieldsProvider";
import { PublicAssetSEO } from "../PublicBoardLayout/PublicAssetSEO";
export const PublicClip = (param)=>{
    let { shortId, initialData } = param;
    return /*#__PURE__*/ _jsx(AccountProvisionerProvider, {
        children: /*#__PURE__*/ _jsx(PublicAccountProvider, {
            children: /*#__PURE__*/ _jsx(PublicPermissionsProvider, {
                permissions: initialData.permissions,
                children: /*#__PURE__*/ _jsx(PublicAssetReduxProvider, {
                    initialClip: initialData.clip,
                    children: /*#__PURE__*/ _jsx(ShortIdProvider, {
                        shortId: shortId,
                        objectId: initialData.clip.id,
                        objectType: "clip",
                        children: /*#__PURE__*/ _jsx(PublicWorkspaceProvider, {
                            ...initialData.clip,
                            children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                                children: /*#__PURE__*/ _jsx(PublicClipSocketContextProvider, {
                                    children: /*#__PURE__*/ _jsx(ConnectedRouter, {
                                        children: /*#__PURE__*/ _jsx(FiltersProvider, {
                                            children: /*#__PURE__*/ _jsx(ModalProvider, {
                                                children: /*#__PURE__*/ _jsx(MaintenanceMode, {
                                                    children: /*#__PURE__*/ _jsxs(PublicClipCustomFieldsProvider, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(PublicAssetSEO, {
                                                                clip: initialData.clip
                                                            }),
                                                            /*#__PURE__*/ _jsx(AnnotationProvider, {
                                                                children: /*#__PURE__*/ _jsx(PublicAsset, {
                                                                    requireAccount: initialData.requireAccount,
                                                                    initialClip: initialData.clip
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(PublicClipActivityContainer, {})
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
